export default __webpack_public_path__ + "static/media/classroom.c090b097.jpg";